export enum RoutePlacementEnum {
  MAIN_NAVIGATION,
  SUB_NAVIGATION,
}
